const SignIn = {

    // PAGE HEADER
    "tagline": "आइए शुरू करें",
    "sub_tagline": "जीवनभर के कार्यक्रम के एक कदम करीब",

    // FIELDS
    "email": "ईमेल",
    "password": "पासवर्ड",

    // FOOTER
    "forgot_password": "क्या आप अपना पासवर्ड भूल गए?",
    "reset": "रीसेट करें",
    "footer_tagline_1": "क्या आपका खाता नहीं है?",
    "footer_tagline_2": "जारी रखते हुए, आप अरोक्कियम से सहमत होते हैं",
    "t&c": "सेवा की शर्तें ",
    "and": "और",
    "prv&pol": "गोपनीयता नीति",

    // TOAST
    "success_add": "सफलतापूर्वक लॉगिन हुआ!!..",
    "server_error": "सर्वर त्रुटि!!..",
    "wrong": "कुछ गलत हो गया!!..",

    // ERROR
    "error_email": "कृपया ईमेल दर्ज करें",
    "error_password": "कृपया पासवर्ड दर्ज करें",

}

export default SignIn;